const initial = {
  fontFamily: "JWSansBold",
  fontWeight: "normal",
  background: "black",
  color: "#ffffff",
  padding: "12px 5px 8px",
  textTransform: "uppercase",
  width: "100%",
  textAlign: "center",
  cursor: "pointer",
  border: "none",
  outline: "none",
  fontSize: "14px",
  lineHeight: "24px",
  letterSpacing: "2.5px",
  ":hover": {
    background: "linear-gradient(90deg, #C7BB83, #D5C17D)"
  }
};

const selected = {
  ...initial,
  background: "linear-gradient(90deg, #EEE0A7, #D5C17D)"
};

const preview = {
  ...initial,
  margin: "7px auto 0 auto",
  maxWidth: "330px",
  display: "block"
};

const restart = {
  ...initial,
  background: "transparent",
  color: "#FFFFFF",
  ":hover": {
    background: "transparent"
  }
};

const blue = {
  ...initial,
  background: "#0F6ABE",
  color: "#FFFFFF"
};

const outline = {
  ...initial,
  background: "#ffffff",
  color: "#000000",
  border: "2px solid #000000",
  padding: "8px 5px"
};

const outlineMaxWidth = {
  ...outline,
  margin: "7px auto 0 auto",
  display: "block",
  maxWidth: "330px"
};

const continueBtn = {
  ...initial,
  maxWidth: "200px"
};

export default { initial, selected, preview, restart, blue, outline, outlineMaxWidth, continueBtn };



// WEBPACK FOOTER //
// ./src/styles/ctas.js